<template>
    <div>
        <b-button
            block
            @click="openSidebar()"
        >
            ขอจบงานนอกเวลา
        </b-button>
        <SidebarJobPartTime 
            :isVisible.sync="isVisible" 
        />
    </div>
</template>

<script>
import SidebarJobPartTime from "@/components/Job/SidebarJobPartTime.vue";

export default {
    components:{
        SidebarJobPartTime
    },
    data(){
        return {
            isVisible: false
        }
    },
    methods:{
        openSidebar(){
            this.isVisible = true
        }
    }
}
</script>
